import { render } from "./FormSkeleton.vue?vue&type=template&id=6d1712c2&scoped=true&ts=true"
import script from "./FormSkeleton.vue?vue&type=script&lang=ts"
export * from "./FormSkeleton.vue?vue&type=script&lang=ts"

import "./FormSkeleton.vue?vue&type=style&index=0&id=6d1712c2&lang=scss&scoped=true"

import exportComponent from "/Users/wangkaining/Code/vue_code/newapps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1712c2"]])

export default __exports__